import CityPage from '../../components/Pages/CityPage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function CityPageWrapper() {
  const shouldBePage = pages.city;
  const conditionTypes = {
    page: true,
  };

  return (
    <PageWrapper
      pageToLoad={<CityPage />}
      shouldBePage={shouldBePage}
      conditions={conditionTypes}
    />
  );
}
